const Search = ({ width = "24", height = "24" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 22.3333C17.5578 22.3333 22.3335 17.5577 22.3335 11.6667C22.3335 5.77563 17.5578 1 11.6667 1C5.77566 1 1 5.77563 1 11.6667C1 17.5577 5.77566 22.3333 11.6667 22.3333Z"
        stroke="#08183F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 25L19.2 19.2"
        stroke="#08183F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Search;
